import React from 'react'
import { CardHeader } from '@mui/material';

const Feature = () => {
    return ( 
       <div>
        <div className='justify-content-center container'>
         <div className='color-text row'>
        <div className='col-md-4 text-center' data-aos="fade-right">
           <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset2.webp' width='100%' />
            <p className='mt-2'>
                ประมาณการเงิน กบข. ณ วันเกษียณของสมาชิก จากอัตราการออมเพิ่ม และแผนการลงทุนในปัจจุบัน คำนวณตามสมมติฐานต่าง ๆ เพื่อให้สมาชิกสามารถประเมินผลและพิจารณาวางแผนเกษียณที่เหมาะกับตนเองได้
            </p>
        </div>
        <div className='col-md-4 text-center' data-aos="fade-up">
            <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset3.webp' width='100%' />
            <p className='mt-2'>
                Twin ของสมาชิกที่ปรับได้ตามใจ โดยสมาชิกสามารถทดลองปรับอัตราการออมเพิ่ม และ เลือกเปลี่ยนแผนการลงทุนได้เอง เพื่อเปรียบเทียบประมาณการเงิน กบข. กับ My GPF
            </p>
        </div>
        <div className='col-md-4 text-center' data-aos="fade-down">
            <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset4.webp' width='100%' />
            <p className='mt-2'>
                Twin ของสมาชิกที่ กบข. จะออกแบบทางเลือกตามเป้าหมายที่ตั้งไว้ ตามระดับความเสี่ยงจากการลงทุนของสมาชิก
            </p>
        </div>
    </div>
    </div>
    <div className='pt-5 pb-5' />
    <CardHeader title={(<h3 className='text-center colorbase'>เปรียบเทียบประมาณการเงิน กบข.</h3>)} />
    <div className='justify-content-center container'>
    <div className='color-text row mt-1'>
        <div className='col-md-6 text-center'>
            <h5 className='border-primary bg-header pt-1 pb-1 rounded text-light mb-3'>เปรียบเทียบ กับ Twins ของคุณ</h5>
            <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset5.webp' width='100%' />
        </div>
        <div className='col-md-6 text-center'>
            <h5 className='border-primary bg-header pt-1 pb-1 rounded text-light mb-3'>เปรียบเทียบกับเพื่อนสมาชิกของคุณ</h5>
            <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset6.webp' width='100%' />
        </div>
    </div>
    <p className='colorbase mt-2 text-center'>
    หลังจากที่สมาชิกได้สร้าง My GPF & My GPF Twins แล้ว ระบบจะเปรียบเทียบประมาณการเงิน กบข. ให้สมาชิกเห็นภาพชัดเจนยิ่งขึ้น เพื่อติดตามและประเมินดูว่าสมาชิกควรเลือกลงทุนแบบเดิม หรือจะเลือกอัตราออมเพิ่ม หรือ เปลี่ยนแผนการลงทุนแบบไหนดีที่จะทำให้บรรลุเป้าหมายวันเกษียณที่ตั้งไว้
    </p>
    </div>
       </div>
     );
}
 
export default Feature;